export interface ImageDesc { name: string, title: { de: string; en: string }, image: string, format: string, nrPages: number, versionNr: string };

export const itemDataAll = [
    {
        name: "Pinoccothek",
        title: {
            "de": "Pinoccothek",
            "en": "Pinoccothek"
        },
        image: "00",
        format: "portrait",
        nrPages: 48,
        versionNr: "0"
    },
    {
        name: "Pinocchiade",
        title: {
            "de": "Pinocchiade",
            "en": "Pinocchiade"
        },
        image: "00",
        format: "portrait",
        nrPages: 80,
        versionNr: "0"
    },
    {
        name: "Augustin",
        title: {
            "de": "Der Lieber Augustin",
            "en": "Dear Augustine"
        },
        image: "00",
        format: "portrait",
        nrPages: 40,
        versionNr: "0"
    },
    {
        name: "PinoccothekRU",
        title: {
            "de": "Pinoccothek (Ru)",
            "en": "Pinoccothek (Ru)"
        },
        image: "00",
        format: "portrait",
        nrPages: 48,
        versionNr: "0"
    },
    {
        name: "PinocchiadeRU",
        title: {
            "de": "Pinocchiade (Ru)",
            "en": "Pinocchiade (Ru)"
        },
        image: "00",
        format: "portrait",
        nrPages: 92,
        versionNr: "0"
    },
    {
        name: "ZFBV",
        title: {
            "de": "Die blauen Vögel der «Zauberflöte»",
            "en": "Синие птицы «Волшебной флейты»"
        },
        image: "00-Seite0",
        format: "portrait",
        nrPages: 84,
        versionNr: "0"
    }
];